import request from '@/libs/request';
import RSA from '@/libs/rsa';
import md5 from 'md5';
import config from '@/config';

/**
 * 登录
 */
export const LoginSubmit = params => {
  const data = params;

  // 对用户名密码进行RAS加密
  data.userName = RSA.encrypt(params.userName);
  data.password = RSA.encrypt(md5(params.password));

  return request('post', `${config.api_base}/api/unauth/login`, data);
};

/**
 * 退出登录
 */
export const LogoutSubmit = data => {
  return request('post', `${config.api_base}/api/unauth/logout`, data);
};
